import type { Route } from 'vue-router'
import { ReservedQueryKey } from '~/core/enums/routing'

export const buildNextQuery = (next: string, preselectedCountry: Route['query'][string]) => {
  // NOTE: Escape символа "&", чтобы остальные query параметры распознались не отдельно, а как часть next
  let query = '?next=' + encodeURIComponent(
    next.replaceAll(`${ReservedQueryKey.PreselectedCountry}=${preselectedCountry}`, ''),
  )

  if (preselectedCountry) {
    query += `&${ReservedQueryKey.PreselectedCountry}=${preselectedCountry}`
  }

  return query
}
